import React, { createContext, useContext, useState } from 'react';

type TabsContextValues = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};

const TabsContext = createContext<TabsContextValues | undefined>(undefined);

type CalculateMaximumMortgageTabsProviderProps = {
  children: React.ReactNode;
};

export const CalculateMaximumMortgageTabsProvider: React.FC<CalculateMaximumMortgageTabsProviderProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<string>('incomes');

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </TabsContext.Provider>
  );
};

export const useCalculateMaximumMortgageTabs = () => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error('useCalculateMaximumMortgageTabs must be used within a CalculateMaximumMortgageTabsProvider');
  }
  return context;
};